export default "__VITE_ASSET__DB89Rcif__"